import Api from "../../../util/Api";

export default function getInitState() {
    return {
        formIsOpen: false,
        gridIsOpen: true,

        actions: [
            {
                btn_text: '<i class="fas fa-plus"></i> Gyógyszer hozzáadása',
                event_name: "customClick",
                class: "btn btn-success",
                event_payload: 'addDrug',
                additionalButtonVisible:'isCompanySiteDeactivated'
            },
            {
                btn_text: '<i class="fas fa-plus"></i> GYSE hozzáadása',
                event_name: "customClick",
                class: "btn btn-success",
                event_payload: 'addGYSE'
            },
            {
                btn_text: '<i class="fas fa-print"></i> Nyomtatás',
                event_name: "customClick",
                class: "btn btn-primary",
                event_payload: 'printCertificate'
            }
        ],
        formActions: [
            {
                btn_text: '<i class="fa fa-backward"></i> Vissza',
                event_name: "customClick",
                class: "btn btn-warning mx-1",
                event_payload: 'backToGrid'
            },
            {
                btn_text: '<i class="fas fa-prescription-bottle-alt"></i> Termék kiválasztása',
                event_name: "customClick",
                class: "btn btn-info mx-1",
                event_payload: 'openDrugSelectDialog'
            },
            {
                btn_text: '<i class="fas fa-trash"></i> Reset',
                event_name: "customClick",
                class: "btn btn-secondary mx-1",
                event_payload: 'resetForm'
            }
        ],
        rowActions: [
            {
                btn_text: '<i class="fas fa-trash"></i>',
                title: 'Törlés',
                event_name: "customClick",
                class: "btn btn-outline-danger",
                event_payload: 'deleteRow'
            },
            {
                btn_text: '<i class="fas fa-undo"></i>',
                title: 'Visszaállítás',
                event_name: "customClick",
                class: "btn btn-outline-warning",
                seeCaseOfDeleted: true,
                event_payload: 'unDeleteRow'
            }
        ],
        headerFields: [
            {
                name: "id",
                label: "Azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "patientId",
                label: "Páciens azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "idTermek",
                label: "Gyógyszer azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "bnoId",
                label: "BNO azonosító",
                visibility: false,
                formVisible: false,
            },
            {
                name: "productType",
                label: "Terméktípus",
                visibility: false,
                formVisible: false,
            },
            {
                name: "nev",
                label: "Termék név",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 4
            },
            {
                name: "drugTtt",
                label: "TTT kód",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 1
            },
            {
                name: "iso",
                label: "ISO kód",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 1
            },
            {
                name: "jogcim",
                label: "Jogcím",
                visibility: false,
                formVisible: true,
                formReadOnly: false,
                formType: "select",
                formSize: 1,
                selectOptions: {
                    apiCallback: Api.getJogcimList,
                    formatText: function(val){
                        return val.text;
                    },
                    formatOption: function(val){
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'eesztId',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "kisznev",
                label: "Kiszerelés",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 2
            },
            {
                name: "gyforma",
                label: "Gyógyszerforma",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 2
            },
            {
                name: "rendelhet",
                label: "Felírható",
                visibility: false,
                formVisible: true,
                formReadOnly: true,
                formType: "text",
                formSize: 1
            },
            {
                name: "bnoId",
                label: "BNO",
                visibility: false,
                formVisible: true,
                formRequired: true,
                formType: "selectBNOSingle",
                formSize: 4,
                selectOptions: {
                    formatText: function(val){
                        return val.leiras;
                    },
                    returnValue: "id"
                }
            },
            {
                name: "dailyAmount",
                label: "Napi mennyiség",
                visibility: false,
                formVisible: true,
                formType: "text",
                formSize: 2
            },
            {
                name: "dosage",
                label: "Adagolás",
                visibility: false,
                formVisible: true,
                formType: "text",
                formSize: 3
            },
            {
                name: "specialistStampNo",
                label: "Felíró szakorvos pecsétszáma",
                description: "Ha a gyógyszert csak szakorvos rendelheti vagy a javaslatot a szakorvos tette!",
                visibility: false,
                formVisible: true,
                formType: "text",
                formSize: 2
            },
            {
                name: "note",
                label: "Megjegyzés",
                visibility: false,
                formVisible: true,
                formType: "text",
                formSize: 6
            },
            {
                name: "bnoCode.kod",
                label: "BNO kód",
                formVisible: false,
                sort: true
            },
            {
                name: "drug.atc",
                label: "ATC kód",
                formVisible: false,
                sort: true
            },
            {
                name: "drug.iso",
                label: "ISO kód",
                formVisible: false,
                sort: true
            },
            {
                name: "drug.nev",
                label: "Gyógyszer",
                formVisible: false,
                sort: true
            },
            {
                name: "dailyAmount",
                label: "Mennyiség",
                slot_name: "noFormat",
                formVisible: false
            },
            {
                name: "dosage",
                label: "Adagolás",
                slot_name: "noFormat2",
                formVisible: false
            },
            {
                name: "specialistStampNo",
                label: "Pecsétszám",
                slot_name: "recommendedDosageFormat",
                formVisible: false
            },
            {
                name: "buttons",
                label: "Opciók",
                sort: false,
                formVisible: false
            }
        ],
    }
}
